import React, { useState } from "react";
import axios from "axios";

import { useDocumentModal } from "../common/CustomModal/CustomModalContext";
import { mediaRoute, getClientId, getCaseId } from "../../Utils/helper";
import UploadDocModal from "../../Components/DocumentRow/UploadDocModal";
import TableLoader from "../Loaders/tableLoader";
import api from "../../api/api";
import ButtonLoader from "../Loaders/ButtonLoader";
import DocumentUploadModal from "../Modals/documentUploadModal";
import addIconGold from "../../assets/Add-icon-gold.svg";

// import { DefaultViewCard2 } from "./defaultViewCard";

const Treatment = ({ data, loading, refetchData, refetchLoading }) => {
  const { showDocumentModal } = useDocumentModal();
  const origin = process.env.REACT_APP_BACKEND_URL;
  const currentCase = getCaseId();
  const client = getClientId();
  const [showDocModal, setShowDocModal] = useState(false);
  const [selectedSlotId, setSelectedSlotId] = useState(null);
  const [selectedPanelId, setSelectedPanelId] = useState(null);
  const [selectedPageId, setSelectedPageId] = useState(null);
  // const [uploadingSlot, setUploadingSlot] = useState({ slotId: null, panelId: null });
  const uploadingSlot = {
    slotId: null,
    panelId: null,
  };
  const [isDragging, setIsDragging] = useState(false);

  // State for handling modal and upload progress
  const [fileUploadModal, setFileUploadModal] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadFile, setUploadFile] = useState("");
  const handleUploadPopup = (slotId, panelId, pageId) => {
    setSelectedSlotId(slotId);
    setSelectedPanelId(panelId);
    setSelectedPageId(pageId);
    setShowDocModal(true);
  };

  const handleDocPreview = (doc) => {
    axios
      .get(`${origin}/api/attorney-staff/${doc.attached_by.id}/profile-image/`)
      .then((response) => {
        doc.attached_by.profile_pic_29p = mediaRoute(response.data.profile_image);
      })
      .catch((error) => {
        console.error(`Error fetching profile image: ${error}`);
      });
    showDocumentModal("document", doc.upload, doc, refetchData);
  };

  const handleClose = () => {
    setShowDocModal(false);
    setSelectedSlotId(null);
    setSelectedPanelId(null);
    setSelectedPageId(null);
  };

  const addDocumentHandler = () => {
    setShowDocModal(false);
    setSelectedSlotId(null);
    setSelectedPanelId(null);
    setSelectedPageId(null);
  };
  const simulateProgress = (setUploadProgress) => {
    let progress = 0;

    const intervalId = setInterval(() => {
      progress += 1;
      setUploadProgress(progress);

      // Stop once we reach 100%
      if (progress >= 100) {
        clearInterval(intervalId);
      }
    }, 300); // 300ms delay between increments
  };
  const handleDrop = async (e, slot_id, pageId, panel_id) => {
    e.preventDefault();
    setFileUploadModal(true);
    simulateProgress(setUploadProgress); // Simulate gradual progress
    // setUploadingSlot({ slotId: slot_id, panelId: panel_id });
    const files = e.dataTransfer.files;
    const fileSizeInMB = files[0].size / (1024 * 1024);
    setUploadFile(files[0].name);
    const formData = new FormData();
    formData.append("file", files[0]);

    try {
      const response = await api.post(
        `/api/upload_doc/${getClientId()}/${getCaseId()}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const docId = response?.data?.docId;
      await api.post("api/doc/attach/", {
        panel_id: panel_id,
        slot: slot_id,
        page_id: pageId,
        case_id: getCaseId(),
        panels: true,
        doc_id: docId,
        file_size: fileSizeInMB,
      });
      await refetchData();
    } catch (error) {
      console.error(error);
    } finally {
      setIsDragging(false);
      setFileUploadModal(false);
    }
  };
  const [isDragginguploadingbutton, setIsDragginguploadingbutton] = useState(false);
  const [_uploadbuttonLoadingid, setuploadbuttonLoadingid] = useState(null);

  const handleDropwithOutpanlesWithoutslots = async (e, panel, pageId, panelId) => {
    e.preventDefault();
    if (panel) {
      setFileUploadModal(true);
      simulateProgress(setUploadProgress); // Simulate gradual progress
      setuploadbuttonLoadingid(panelId);

      const files = e.dataTransfer.files;
      const fileSizeInMB = files[0].size / (1024 * 1024);
      setUploadFile(files[0].name);
      const formData = new FormData();
      formData.append("file", files[0]);

      try {
        const response = await api.post(
          `/api/upload_doc/${getClientId()}/${getCaseId()}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        const docId = response?.data?.docId;
        await api.post("api/doc/attach/", {
          page_id: pageId,
          case_id: getCaseId(),
          doc_id: docId,
          file_size: fileSizeInMB,
        });
        await refetchData();
      } catch (error) {
        console.error(error);
      } finally {
        setIsDragginguploadingbutton(false);
        setuploadbuttonLoadingid(null);
        setFileUploadModal(false);
      }
    } else {
      setFileUploadModal(true);
      simulateProgress(setUploadProgress);
      const files = e.dataTransfer.files;
      const fileSizeInMB = files[0].size / (1024 * 1024);
      const formData = new FormData();
      formData.append("file", files[0]);

      try {
        const response = await api.post(
          `/api/upload_doc/${getClientId()}/${getCaseId()}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        const docId = response?.data?.docId;
        await api.post("api/doc/attach/", {
          page_id: pageId,
          case_id: getCaseId(),
          doc_id: docId,
          file_size: fileSizeInMB,
        });
        await refetchData();
      } catch (error) {
        console.error("Failed to handle drop:", error);
      } finally {
        setIsDragginguploadingbutton(false);
        setFileUploadModal(false);
      }
    }
  };

  const handleUploadPopupwithoutSlots = (pageId) => {
    setSelectedPageId(pageId);
    setShowDocModal(true);
  };
  const isSlotUploading = (slotId, panelId) => {
    return uploadingSlot?.slotId === slotId && uploadingSlot?.panelId === panelId; // Added parentheses for clarity
  };
  const _unAttachedDocuments = () => {
    const unattached = [];
    const addedIds = new Set();

    if (!data) return [];

    const page = data.data;
    if (page.slots && Array.isArray(page.slots)) {
      page.slots?.forEach((slot) => {
        if (slot.docs && Array.isArray(slot.docs)) {
          slot.docs?.forEach((doc) => {
            if (
              (doc.document_slot === null || doc.document_slot?.slot_number === 0) &&
              !addedIds.has(doc.id)
            ) {
              unattached.push(doc);
              addedIds.add(doc.id);
            }
          });
        }
      });
    }

    if (page?.page?.panels && Array.isArray(page.panels)) {
      page.panels?.forEach((panel) => {
        if (panel.docs && Array.isArray(panel.docs)) {
          panel.docs.forEach((doc) => {
            if (
              (doc.document_slot === null || doc.document_slot?.slot_number === 0) &&
              !addedIds.has(doc.id)
            ) {
              unattached.push(doc);
              addedIds.add(doc.id);
            }
          });
        }
      });
    }

    return unattached;
  };
  if (loading) {
    return (
      <>
        <TableLoader />
      </>
    );
  }

  if (!data) {
    return <div>No Data</div>;
  }

  return (
    <div>
      <div className="m-b-5 flex-nowrap align-items-center">
        <div className="panel-icon" style={{ marginRight: "5px", left: "0px" }}>
          <img
            src={data?.data?.page?.page_icon}
            className="ic ic-25 d-flex align-items-center justify-content-center"
          />
        </div>
        <div
          className="panel-color"
          style={{
            background: "var(--primary)",
            left: "33px",
            display: "flex",
            alignItems: "center",
            fontWeight: "600",
            fontSize: "16px",
            fontFamily: "Inter",
            textTransform: "uppercase",
          }}
        >
          {/* <div style={{ height: 0, width: "10px" }} /> */}
          <h4
            className="d-flex align-items-center"
            style={{ color: "white", height: "max-content", paddingLeft: "9px" }}
          >
            <small className="font-weight-600 anti-skew" style={{ textDecoration: "none" }}>
              {data?.data?.page?.name}
            </small>
          </h4>
        </div>
      </div>
      {data?.data?.panels?.map((item) => (
        <div key={item.id} className=" m-b-5 m-t-5">
          <div className="document-panel-wrapper m-b-0">
            <div
              className="d-flex align-items-center"
              style={{
                cursor: "default",
                background: item?.specialty?.secondary_color,
                width: "100%",
                height: "25px",
                fontWeight: 600,
              }}
            >
              <div
                style={{
                  width: "25px",
                  minWidth: "25px",
                  height: "25px",
                  backgroundColor: item?.specialty?.color,
                  color: "white",
                  fontSize: "16px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <p
                  style={{
                    textTransform: "uppercase",
                    textAlign: "center",
                    margin: "0 auto",
                    fontWeight: "bold",
                  }}
                >
                  {item?.specialty?.name[0]}
                </p>
              </div>
              <p
                style={{
                  color: "black !important",
                  fontSize: "14px",
                  margin: "0",
                  padding: "0 5px",
                  textTransform: "sentencecase",
                }}
              >
                {item?.panel_name || item?.specialty?.name}
              </p>
            </div>
            <div
              className="tbdocument redtd2 flex-row m-t-5 m-0 m-r-5"
              style={{
                gap: "5px",
              }}
            >
              <div className="col p-0 ">
                {/* <div className="height-25 m-b-5">
                  <h4
                    // style={{ backgroundColor: "var(--primary-15)" }}
                    className="bg-primary-5 text-capitalize d-flex align-items-center justify-content-center h-100 text-lg text-upper-case font-weight-semibold text-center client-contact-title"
                  >
                    {item?.panel_name || ""} Document Row
                  </h4>
                </div> */}
                <div
                  className="icon-text-boxes d-flex flex-wrap w-100 e-template-row height-25 m-t-5"
                  style={{ marginRight: "10px", height: "auto" }}
                >
                  {data?.data?.slots?.slice(1, data?.data?.slots?.length)?.map((slot) => {
                    const attachedDocs = item?.docs?.filter(
                      (doc) => doc?.document_slot?.id === slot?.id
                    );
                    return (
                      <React.Fragment key={slot.id}>
                        {attachedDocs?.length > 0
                          ? attachedDocs.map((doc) => (
                              <div
                                className="col-12 col-md-6 col-xl-3 icon-text-box text-center height-25 btn-primary-lighter-2 font-weight-semibold  cursor-pointer"
                                id="no-vertical-border"
                                onClick={() => handleDocPreview(doc)}
                                key={doc.id}
                              >
                                <p className="date">{new Date(doc.created).toLocaleDateString()}</p>
                                <span className="icon-wrap">
                                  <i className="ic ic-19 ic-file-colored cursor-pointer img-19px" />
                                </span>
                                <p className="name">
                                  <span className="text-primary-25">{slot?.slot_number}.</span>{" "}
                                  {doc.file_name || slot.slot_name}
                                </p>
                              </div>
                            ))
                          : slot?.slot_number !== 0 && (
                              <div
                                onDrop={(e) =>
                                  handleDrop(e, slot.id, data?.data?.page?.id, item?.id)
                                }
                                className={`col-12 col-md-3 col-xl icon-text-box text-center dropzone-${slot.id}-${item.id}-${data.data?.page.id} height-25 btn-primary-lighter-2-empty font-weight-semibold cursor-pointer`}
                                id="no-vertical-border"
                                onClick={() =>
                                  handleUploadPopup(slot?.id, item?.id, data?.data?.page?.id)
                                }
                              >
                                {isSlotUploading(slot?.id, item?.id) &&
                                (isDragging || refetchLoading) ? ( // Corrected condition
                                  <div className="d-flex align-items-center justify-content-center">
                                    <ButtonLoader />
                                    <span style={{ marginLeft: "5px" }}>Uploading</span>
                                  </div>
                                ) : (
                                  // Unchanged code
                                  <>
                                    <span className="icon-wrap">
                                      <i className="ic ic-19 ic-custom-icon-cloud-2 cursor-pointer img-19px" />
                                    </span>
                                    {slot.slot_name ? (
                                      <p
                                        className="name"
                                        style={{
                                          color: "var(--primary-25)",
                                        }}
                                      >
                                        <span className="text-primary-25">
                                          {slot?.slot_number}.
                                        </span>{" "}
                                        {slot?.slot_name}
                                      </p>
                                    ) : (
                                      <p
                                        className="name"
                                        style={{
                                          color: "var(--primary-25)",
                                        }}
                                      >
                                        <span className="text-primary-25">
                                          {slot?.slot_number}.
                                        </span>{" "}
                                        Available
                                      </p>
                                    )}
                                  </>
                                )}
                              </div>
                            )}
                      </React.Fragment>
                    );
                  })}{" "}
                </div>
              </div>
              {/* <div
                className="icon-text-box text-center order-last btn-primary-lighter-2 font-weight-semibold cursor-pointer"
                onDrop={(event) =>
                  handleDropwithOutpanlesWithoutslots(event, true, data?.data?.page?.id, item?.id)
                }
                style={{
                  background: "var(--primary-10)",
                  width: "70px",
                  height: "55px",
                }}
                onClick={() => handleUploadPopupwithoutSlots(data?.data?.page?.id)}
              >
                <div className="upload-icon border-0 rounded-0 bg-transparent">
                  <div className="d-flex align-items-center width-inherit justify-content-center">
                    {isDragginguploadingbutton && item?.id === uploadbuttonLoadingid ? (
                      <>
                        <ButtonLoader />
                        <span style={{ marginLeft: "5px" }}>Uploading..</span>
                      </>
                    ) : (
                      <>
                        <span
                          className="fw-bold d-flex align-items-center justify-content-center text-gold h5 m-0 height-21 m-r-5"
                          style={{
                            width: "15px",
                            minWidth: "15px",
                          }}
                        >
                          <img
                            src={addIconGold}
                            className="ic ic-15 d-flex align-items-center justify-content-center"
                          />
                        </span>
                        <div className="d-flex flex-column">
                          <span
                            className="text-primary  pt-0"
                            style={{
                              flexWrap: "wrap",
                              fontFamily: "Inter",
                            }}
                          >
                            Save
                          </span>
                          <span
                            className="text-primary  pt-0"
                            style={{
                              flexWrap: "wrap",
                              fontFamily: "Inter",
                            }}
                          >
                            to
                          </span>
                          <span
                            className="text-primary  pt-0"
                            style={{
                              flexWrap: "wrap",
                              fontFamily: "Inter",
                            }}
                          >
                            Page
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      ))}
      {(data?.data?.panels === null || data?.data?.panels?.length === 0) &&
      data?.data?.slots?.length > 0 ? (
        <div
          className="icon-text-box text-center order-last  btn-primary-lighter-2 font-weight-semibold  cursor-pointer"
          onDrop={(event) =>
            handleDropwithOutpanlesWithoutslots(event, false, data?.data[0]?.page?.id, null)
          }
          style={{
            background: "var(--primary-10)",
            width: "70px",
            height: "55px",
          }}
          onClick={() => handleUploadPopupwithoutSlots(data?.data[0]?.page?.id)}
        >
          <div className="upload-icon border-0 rounded-0 bg-transparent dropzone-{data.page.id}-{clientProvider.id}">
            <div className="d-flex align-items-center width-inherit justify-content-center">
              {isDragginguploadingbutton ? (
                <>
                  <ButtonLoader />
                  <span style={{ marginLeft: "5px" }}>Uploading...</span>
                </>
              ) : (
                <>
                  <span
                    className="fw-bold d-flex align-items-center justify-content-center text-gold h5 m-0 height-21 m-r-5"
                    style={{
                      width: "15px",
                      minWidth: "15px",
                    }}
                  >
                    <img
                      src={addIconGold}
                      className="ic ic-15 d-flex align-items-center justify-content-center"
                    />
                  </span>
                  <div className="d-flex flex-column">
                    <span
                      className="text-primary  pt-0"
                      style={{
                        flexWrap: "wrap",
                        fontFamily: "Inter",
                      }}
                    >
                      Save
                    </span>
                    <span
                      className="text-primary  pt-0"
                      style={{
                        flexWrap: "wrap",
                        fontFamily: "Inter",
                      }}
                    >
                      to
                    </span>
                    <span
                      className="text-primary  pt-0"
                      style={{
                        flexWrap: "wrap",
                        fontFamily: "Inter",
                      }}
                    >
                      Page
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      {/* {
        unAttachedDocuments().length > 0 && (
          <>
            <div className="m-l-7 m-b-5 flex-nowrap align-items-center">
              <div
                className="panel-color"
                style={{
                  background: "var(--primary)",
                  left: "25px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    height: 0,
                    width: "10px",
                    maxHeight: "max-content",
                    minHeight: "max-content",
                  }}
                />
                <h4 className="d-flex align-items-center  m-l-5" style={{ color: "white" }}>
                  <small className="font-weight-600 anti-skew">Unattached Documents</small>
                </h4>
              </div>
            </div>
            <div
              // className="icon-text-boxes d-flex flex-wrap w-100 e-template-row m-t-5"
              className="w-100 m-t-5 unattached-documents-container"
              style={{
                marginRight: "5px",
                justifyContent: "end",
                height: "auto",
              }}
            >
              {unAttachedDocuments().map((document) => (
                <DefaultViewCard2
                  key={document.id}
                  doc={document}
                  slot={undefined}
                  handleDocPreview={handleDocPreview}
                />
              ))}
            </div>
          </>
        )
        
      } */}
      <UploadDocModal
        show={showDocModal}
        handleClose={handleClose}
        slot_id={selectedSlotId}
        panel_id={selectedPanelId}
        page_id={selectedPageId}
        caseId={currentCase}
        clientId={client}
        handleDocumentUpload={addDocumentHandler}
        refetchLoading={refetchLoading}
        isDocumentTab={false}
        refetchData={refetchData}
      />
      <DocumentUploadModal
        uploadFile={uploadFile}
        uploadProgress={uploadProgress}
        show={fileUploadModal}
        onHide={() => setFileUploadModal(false)}
      />
    </div>
  );
};

export default Treatment;
